document.addEventListener('DOMContentLoaded', function () {
  const upsellButton = document.querySelector('.new-upsell-atc');
  const modalOverlay = document.querySelector('.custom-upsell-modal-overlay');

  if (modalOverlay) {
    modalOverlay.classList.add('hide');
    // Portal: move to <body> so no parent stacking context can trap it
    document.body.appendChild(modalOverlay);
  }

  if (upsellButton && modalOverlay) {
    upsellButton.addEventListener('click', function () {
      // Check if user has secret access - if so, don't show upsell modal
      const urlParams = new URLSearchParams(window.location.search);
      const isFromSecretSale = urlParams.get('from') === 'secret-sale';
      const hasSecretAccess = sessionStorage.getItem('secretSaleAccess') === 'true' || isFromSecretSale;

      if (hasSecretAccess) {
        // Skip upsell modal for secret sale users - let the form submit normally
        // Open the cart drawer after a short delay to allow the product to be added
        const jsGridCart = document.querySelector('.js-mini-cart');
        if (jsGridCart) {
          setTimeout(() => {
            jsGridCart.classList.add('active');
            // setTimeout(() => {
            // }, 700);
          }, 800);
        }
        return;
      }

      // Add no-scroll class to body to prevent background scrolling
      document.body.classList.add('no-scroll');
      modalOverlay.classList.remove('hide');
    });

    const closeButton = document.querySelector('.upsell-modal-close');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        modalOverlay.classList.add('hide');

        // Remove no-scroll class from body
        document.body.classList.remove('no-scroll');

        // Add active class to js-grid-cart
        const jsGridCart = document.querySelector('.js-mini-cart');
        if (jsGridCart) {
          setTimeout(() => {
            jsGridCart.classList.add('active');
          }, 800);
        }
      });
    }

    // Optional: Close overlay when clicking outside the modal content
    modalOverlay.addEventListener('click', function (event) {
      // Only close if clicking directly on the overlay, not on the modal content
      if (event.target === modalOverlay) {
        modalOverlay.classList.add('hide');

        // Remove no-scroll class from body
        document.body.classList.remove('no-scroll');

        // Add active class to js-grid-cart
        const jsGridCart = document.querySelector('.js-mini-cart');
        if (jsGridCart) {
          setTimeout(() => {
            jsGridCart.classList.add('active');
          }, 800);
        }
      }
    });

    const skipButton = document.querySelector('.upsell-skip-button');
    if (skipButton) {
      skipButton.addEventListener('click', function () {
        // Hide the modal
        modalOverlay.classList.add('hide');

        // Remove no-scroll class from body
        document.body.classList.remove('no-scroll');

        // Add active class to js-grid-cart
        const jsGridCart = document.querySelector('.js-mini-cart');
        if (jsGridCart) {
          setTimeout(() => {
            jsGridCart.classList.add('active');
          }, 800);
        }
      });
    }
  }
});
